/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const VoicemailIconConfig = {
  name: 'VoicemailIcon',
  height: 512,
  width: 640,
  svgPath: 'M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(VoicemailIconConfig);
//# sourceMappingURL=voicemail-icon.js.map